import gql from 'graphql-tag'

export default {
  methods: {
    prepareExtraParameters (extras) {
      let mutationHead = ``
      let mutationParams = ``
      for (let extra of extras) {
        extra = Object.entries(extra).pop()

        mutationHead += `, $${extra[0]}: ${extra[1]}`
        mutationParams += `, ${extra[0]}: $${extra[0]}`
      }

      return { mutationHead, mutationParams }
    },
    sendSetting (data) {
      this.sendData(data)
    },
    sendData (data) {
      console.warn(`Send out`)
      console.warn(data)
    },

    sendMutation (mutationString, mutationParameters, okCallback, failCallback, name, extraStorage = null) {
      // Sends a qwerry to GraphQL
      this.$apollo.mutate({
        mutation: gql`
          ${mutationString}
        `,
        variables: mutationParameters

      }).then((data) => {
        // Ok
        okCallback(data.data[name], extraStorage)
      }).catch((error) => {
        // Fail
        console.error(error)
        failCallback(extraStorage, error)
      })
    },

    async sendAsyncMutation (mutationString, mutationParameters, name, extraStorage = null) {
      try {
        const data = await this.$apollo.mutate({
          mutation: gql`
            ${mutationString}
          `,
          variables: mutationParameters
        });

        return {
          data: data.data[name],
          extraStorage,
        }

      } catch (error) {
        console.error("sendAsyncMutation error", error)
        throw error
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/apiConnector.js